import CalendarEvent from 'mini-calendar-event-types/lib/MiniCalendarEvent';
import { getOwaMiniCommonStrings } from 'owa-strings/owa-mini-common-strings';

/**
 * Given a event type, it returns a localised descriptor of whether it is an instance or a series
 * @param item
 */
export const getEventTypeString = (item: CalendarEvent) => {
    const strings = getOwaMiniCommonStrings();

    if (item?.isSeriesMaster?.()) {
        return strings.eventTypeSeries;
    } else if (item?.isSeriesInstance?.() || item?.IsSeriesInstanceException) {
        return strings.eventTypeInstance;
    }

    return strings.eventTypeEvent;
};
